/**
 * OBLIVION — GoKwik checkout fix for the Botanical theme.
 *
 * GoKwik's window.onCheckoutClick(button) starts with
 *   button.lastElementChild.setAttribute('id', 'btn-loader')
 * and silently swallows the error when the button has no child element.
 * The Botanical "Secure checkout" buttons are text-only, so the GoKwik
 * checkout never opened. This wraps onCheckoutClick so that:
 *   1. the clicked button always has a loader element as its last child, and
 *   2. the cart drawer (<dialog> in the top layer) is closed first, otherwise
 *      the GoKwik checkout window opens hidden behind it.
 * Nothing else about the checkout flow is changed.
 */
(function () {
  'use strict';
  if (window.__obGokwikFix) return;
  window.__obGokwikFix = true;

  function ensureLoader(el) {
    if (!el || !el.appendChild) return;
    var last = el.lastElementChild;
    if (last && last.classList && last.classList.contains('ob-gk-loader')) return;
    var loader = document.createElement('span');
    loader.className = 'ob-gk-loader';
    loader.setAttribute('aria-hidden', 'true');
    loader.style.display = 'none';
    el.appendChild(loader);
  }

  function closeDrawer() {
    var drawer = document.getElementById('CartDrawer');
    if (drawer && drawer.open && typeof drawer.close === 'function') drawer.close();
  }

  function wrap(fn) {
    if (typeof fn !== 'function' || fn.__obWrapped) return fn;
    var wrapped = function (el) {
      ensureLoader(el);
      closeDrawer();
      return fn.apply(this, arguments);
    };
    wrapped.__obWrapped = true;
    return wrapped;
  }

  /* GoKwik defines window.onCheckoutClick after its deferred script loads (and may redefine it). */
  var current = wrap(window.onCheckoutClick);
  try {
    Object.defineProperty(window, 'onCheckoutClick', {
      configurable: true,
      enumerable: true,
      get: function () { return current; },
      set: function (value) { current = wrap(value); }
    });
  } catch (e) {
    /* fallback: re-wrap once GoKwik has loaded */
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (typeof window.onCheckoutClick === 'function' && !window.onCheckoutClick.__obWrapped) {
        window.onCheckoutClick = wrap(window.onCheckoutClick);
      }
      if (tries > 60) clearInterval(timer);
    }, 500);
  }
})();
